import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { COMMAND_PRIORITY_HIGH, PASTE_COMMAND } from 'lexical';
import { $getSelection, $isRangeSelection } from 'lexical';

export function ForcePasteAsPlainTextPlugin({ pasteWithoutFormatting }) {
  const [editor] = useLexicalComposerContext();

  useEffect(
    function() {
      const removeListener = editor.registerCommand(
        PASTE_COMMAND,
        event => {
          if (!pasteWithoutFormatting) {
            return false;
          }

          const clipboardData = event.clipboardData;

          if (clipboardData && clipboardData.types.includes('text/plain')) {
            event.preventDefault();
            const plainText = clipboardData.getData('text/plain');

            if (plainText) {
              editor.update(() => {
                const selection = $getSelection();
                if ($isRangeSelection(selection)) {
                  selection.insertText(plainText);
                }
              });
            }
            return true;
          }
          return false;
        },
        COMMAND_PRIORITY_HIGH
      );
      return () => {
        removeListener();
      };
    },
    [editor, pasteWithoutFormatting]
  );

  return null;
}
